export default __webpack_public_path__ + "static/media/image-4.e266100b.png";